<script lang="ts" setup>
</script>
<template>
  <svg width="1em" height="1em" viewBox="0 0 116 128" fill="none" xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet" style="display: inline-block; vertical-align: middle;">
    <path
      d="M98.5417 57.959H17.4583C11.061 57.959 5.875 63.145 5.875 69.5423V110.084C5.875 116.481 11.061 121.667 17.4583 121.667H98.5417C104.939 121.667 110.125 116.481 110.125 110.084V69.5423C110.125 63.145 104.939 57.959 98.5417 57.959Z"
      fill="#F52A51" fill-opacity="0.17" stroke="#F52A51" stroke-width="11.5833" stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M29.042 57.959V34.7923C29.042 27.1121 32.093 19.7464 37.5237 14.3157C42.9544 8.88494 50.3201 5.83398 58.0003 5.83398C65.6806 5.83398 73.0462 8.88494 78.477 14.3157C83.9077 19.7464 86.9587 27.1121 86.9587 34.7923V57.959"
      stroke="#F52A51" stroke-width="11.5833" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>